import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "check-icon-container flex items-center justify-center" }

interface Props {
  /** Is the check icon in checked state */
  status?: boolean
  /** Size of the icon */
  size?: string
  /** Whether the icon is disabled */
  disabled?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'CheckIcon'
},
  __name: 'CheckIcon',
  props: {
    status: { type: Boolean },
    size: { default: '1rem' },
    disabled: { type: Boolean }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VIcon, {
      icon: "$check",
      size: __props.size,
      class: _normalizeClass(["check-icon rounded-sm border-2", { checked: __props.status, disabled: __props.disabled }])
    }, null, 8, ["size", "class"])
  ]))
}
}

})